module.exports = __webpack_public_path__ + "static/img/official.805e8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrCode/official.png
// module id = 7f4R
// module chunks = 12